import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CoreFormGroup } from 'components/core/library/form';

import './formGroup.scss';

export default function FormGroup({ children, className, direction = 'row' }) {
	return (
		<CoreFormGroup
			className={classnames(className, direction)}
		>
			{Children.toArray(children)}
		</CoreFormGroup>
	);
}

FormGroup.propTypes = {
	direction: PropTypes.oneOf(['row', 'column']),
	className: PropTypes.string,
	children: PropTypes.node
};

